import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';

import { Subscription } from 'rxjs'
import { SidenavService } from './_services/sidenav.service';
import { DevicesService } from './_services/devices.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'tuGessiEcommerce';

  @ViewChild('sidenav') public sidenav: MatSidenav;

  mediaSub: Subscription;
  diviceXs: boolean;
  diviceSm: boolean;

  constructor(public mediaObserver: MediaObserver, private sidenavService: SidenavService, private devicesService: DevicesService){
  }

  ngOnInit(){
    this.mediaSub = this.mediaObserver.media$.subscribe((result:MediaChange)=> {
      this.devicesService.changeDevice(result.mqAlias);
      this.diviceXs = result.mqAlias === 'xs' ? true : false;
      this.diviceSm = result.mqAlias === 'sm' ? true : false;
    })
  }

  ngAfterViewInit() {
    this.sidenavService.setSidenav(this.sidenav);
    
  }

  ngOnDestroy(){
    this.mediaSub.unsubscribe()
  }
}
